const FALLBACK_OFFSET_MINUTES = Object.freeze({
    'Asia/Seoul': 540,
    'Asia/Tokyo': 540,
    UTC: 0,
    'Etc/UTC': 0,
    GMT: 0,
});
const PROBE_INSTANT_MS = Date.UTC(2026, 0, 15);
const PROBE_EXPECTED_OFFSET_MS = 9 * 60 * 60 * 1000;
let intlZoneSupport;
const formatterCache = new Map();
function getFormatter(timeZone) {
    let formatter = formatterCache.get(timeZone);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat('en-US', {
            timeZone,
            hour12: false,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
        formatterCache.set(timeZone, formatter);
    }
    return formatter;
}
function readZonedParts(timeZone, instantMs) {
    const parts = getFormatter(timeZone).formatToParts(new Date(instantMs));
    const fields = {};
    for (const part of parts) {
        if (part.type === 'literal')
            continue;
        fields[part.type] = Number(part.value);
    }
    if (fields['hour'] === 24)
        fields['hour'] = 0;
    return fields;
}
function computeOffsetViaIntl(timeZone, instantMs) {
    const f = readZonedParts(timeZone, instantMs);
    const asIfUtc = Date.UTC(f['year'] ?? 1970, (f['month'] ?? 1) - 1, f['day'] ?? 1, f['hour'] ?? 0, f['minute'] ?? 0, f['second'] ?? 0);
    return asIfUtc - instantMs;
}
export function hasIntlTimeZoneSupport() {
    if (intlZoneSupport === undefined) {
        try {
            intlZoneSupport =
                computeOffsetViaIntl('Asia/Seoul', PROBE_INSTANT_MS) === PROBE_EXPECTED_OFFSET_MS;
        }
        catch {
            intlZoneSupport = false;
        }
    }
    return intlZoneSupport;
}
export function resetTimeZoneSupportProbe() {
    intlZoneSupport = undefined;
    formatterCache.clear();
}
export function getZoneOffsetMs(timeZone, instantMs) {
    if (hasIntlTimeZoneSupport()) {
        try {
            return computeOffsetViaIntl(timeZone, instantMs);
        }
        catch {
        }
    }
    const minutes = FALLBACK_OFFSET_MINUTES[timeZone];
    return (minutes ?? 0) * 60 * 1000;
}
//# sourceMappingURL=zone-offset.js.map